import Immutable from 'immutable';
import getMySubscriptions from './getMySubscriptions';
export default (props) => {
  const { $$data, userRole } = props;
  if ($$data === undefined) {
    // console.error('Missing $$data');
    return Immutable.fromJS([]);
  }
  if (userRole === undefined) {
    // console.error('Missing userRole');
    return Immutable.fromJS([]);
  }
  // console.log($$subscriptions)
  // console.log($$data.get('myfutureevents'))
  // }
  const $$subscriptions = getMySubscriptions(props);
  return $$subscriptions !== undefined && $$subscriptions.size > 0 && $$subscriptions.get(0) !== undefined
    ? $$data.get('myfutureevents').get(0)
    : undefined;
};



// WEBPACK FOOTER //
// ./src/helpers/getMyLiveEvents.jsx